import gql from 'graphql-tag'

export const RESEND_WELCOME_EMAIL = gql`
    mutation ($input: ResendWelcomeEmailInput!) {
        resendWelcomeEmail(input: $input)
    }
`
